import React from 'react';
import {Button} from '../buttons/Button';
import styled from 'styled-components';
import {UeLink} from '../../wraps/link/UeLink.wrap';
import {subNavHeight} from './Subnav.config';
import {AccentColorOptions} from 'epic-ue-theme';

const DownloadBtn = styled.div`
    display: inline-block;
    position: absolute;
    right: 0;
    top: 0;

    &&& {
        button.primary {
            height: ${subNavHeight}px;
            padding: 0 ${(p) => `${p.theme.spacing(2)}px`};
            ${(p) => p.theme.breakpoints.up('xxl')} {
                padding: 0 ${(p) => `${p.theme.spacing(3)}px`};
            }
            min-height: ${subNavHeight}px;
            min-width: auto;
            border: none;
            border-radius: 0;
            .container {
                .button {
                    font-family: ${(p) => p.theme.fonts.brutal.medium};
                    font-size: 11px;
                    line-height: 16px;
                }
            }
        }
    }
`;

export interface SubnavDownloadBtnProps {
    label?: string;
    href?: string;
    accentColor?: AccentColorOptions;
}

export const SubnavDownloadBtn = ({
    label = 'Download',
    href = '/download',
    accentColor = 'sky'
}: SubnavDownloadBtnProps): JSX.Element | null => {
    if (label === '' || href === '') return null;

    return (
        <DownloadBtn>
            <UeLink href={href}>
                <Button type="primary" color={accentColor}>
                    {label}
                </Button>
            </UeLink>
        </DownloadBtn>
    );
};
